import React from "react";
import {useParams} from 'react-router-dom';
import ItemVariantList from "../../components/webshop/ItemVariantList";

const ItemVariantsPage = () => {
    const {itemId} = useParams();

    return <ItemVariantList itemId={itemId}/>
}

export default ItemVariantsPage;
